export enum AssessmentReferenceTypeEnum {
  Case = "Case",
  Snap = "SnapGroup",
}
